export default "__VITE_ASSET__CMjJjp1Q__"